import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Destinations } from "@/components/landing/Destinations";
import { Services } from "@/components/landing/Services";
import { Advisory } from "@/components/landing/Advisory";
import { Process } from "@/components/landing/Process";
import { Testimonials } from "@/components/landing/Testimonials";
import { EnquiryForm } from "@/components/landing/EnquiryForm";
import { Footer } from "@/components/landing/Footer";
import { QuickContact } from "@/components/landing/QuickContact";

export default function LandingPage() {
  const [prefill, setPrefill] = useState(null);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -64 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  const enquire = (data) => {
    setPrefill({ ...data });
    const el = document.getElementById("enquiry");
    if (el && lenisRef.current) lenisRef.current.scrollTo(el, { offset: -64 });
  };

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[#F8FAFC]">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Destinations onEnquire={enquire} />
        <Services />
        <Advisory onEnquire={enquire} />
        <Process />
        <Testimonials />
        <EnquiryForm prefill={prefill} />
      </main>
      <Footer />
      <QuickContact />
    </div>
  );
}
